var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuse-content-wrapper"},[_c('vuse-section-definition',{attrs:{"title":_vm.page,"icon":"dashboard"}}),_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-sheet',{attrs:{"color":"transparent"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }